module.exports = __webpack_public_path__ + "media/images/team_member-ce432aea.png";